import React from 'react';
import { isAfisCyprus, isFotokiklosi, isRebattery } from 'shared-pages/common/constants';

export const useTriggerMailService = () => {
  const triggerMailService = async () => {
    let url = process.env.VITE_APP_WEBAPI.replace('graphql', 'triggermailservice');
    fetch(url);
  };

  return { triggerMailService };
};
